import PropTypes from "prop-types";
export default PropTypes.shape({
  session: PropTypes.string,
  challengeName: PropTypes.string,
  challengeParameters: PropTypes.array
})